import React from "react";

const Terms = () => {
  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <h1 style={styles.heading}>Terms and Conditions</h1>
        <p style={styles.lastUpdated}>Last updated: August 11, 2026</p>

        <p style={styles.paragraph}>
          Welcome to Woolley_Tech. These Terms and Conditions ("Terms") govern
          your use of our website and services. By accessing or using our
          website, you agree to be bound by these Terms. If you do not agree
          with any part of these Terms, please do not use our website.
        </p>

        <h2 style={styles.subheading}>1. Services</h2>
        <p style={styles.paragraph}>
          Woolley_Tech provides web design, web development, and related digital
          services ("Services"). Any specific terms agreed upon in a signed
          proposal, contract, or invoice will form part of these Terms for that
          particular engagement.
        </p>

        <h2 style={styles.subheading}>2. Use of the Website</h2>
        <p style={styles.paragraph}>
          You agree to use our website only for lawful purposes and in a way
          that does not infringe the rights of, restrict, or inhibit anyone
          else's use of the website. You may not misuse the website by
          introducing viruses, malware, or any other harmful material.
        </p>

        <h2 style={styles.subheading}>3. Intellectual Property</h2>
        <p style={styles.paragraph}>
          All content on this website, including text, graphics, logos, images,
          and software, is the property of Woolley_Tech or its licensors and is
          protected by applicable copyright and intellectual property laws.
          Unless otherwise agreed in writing, final deliverables created for
          you become your property upon full payment, while our pre-existing
          tools, frameworks, and libraries remain our intellectual property.
        </p>

        <h2 style={styles.subheading}>4. Payments and Refunds</h2>
        <p style={styles.paragraph}>
          Fees for Services are as set out in the relevant proposal or invoice.
          Unless otherwise stated, a deposit may be required before work begins.
          We do not offer refunds for work already completed. If you are
          unsatisfied with a deliverable, please contact us within 7 days so we
          can review and address your concerns.
        </p>

        <h2 style={styles.subheading}>5. Limitation of Liability</h2>
        <p style={styles.paragraph}>
          To the fullest extent permitted by law, Woolley_Tech shall not be
          liable for any indirect, incidental, special, or consequential
          damages arising from your use of the website or Services. Our total
          liability for any claim shall not exceed the amount you paid for the
          specific Service giving rise to the claim.
        </p>

        <h2 style={styles.subheading}>6. Third-Party Links</h2>
        <p style={styles.paragraph}>
          Our website may contain links to third-party websites that are not
          owned or controlled by us. We are not responsible for the content,
          privacy policies, or practices of any third-party websites.
        </p>

        <h2 style={styles.subheading}>7. Changes to These Terms</h2>
        <p style={styles.paragraph}>
          We may update these Terms from time to time. Any changes will be
          posted on this page with an updated "Last updated" date. Continued
          use of the website after changes are posted constitutes acceptance of
          the revised Terms.
        </p>

        <h2 style={styles.subheading}>8. Governing Law</h2>
        <p style={styles.paragraph}>
          These Terms shall be governed by and construed in accordance with the
          laws of the Republic of Ghana, without regard to its conflict of law
          provisions.
        </p>

        <h2 style={styles.subheading}>9. Contact Us</h2>
        <p style={styles.paragraph}>
          If you have any questions about these Terms, please contact us at{" "}
          <a href="mailto:woolleysamuel06@gmail.com" style={styles.link}>
            woolleysamuel06@gmail.com
          </a>{" "}
          or call us at{" "}
          <a href="tel:+233203790592" style={styles.link}>
            +233 203 790 592
          </a>
          .
        </p>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: "4rem 2rem",
    background: "linear-gradient(to right, #fafafa, #f0e6da)",
    minHeight: "100vh",
  },
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    background: "#fff",
    padding: "3rem",
    borderRadius: "12px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
  },
  heading: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: "#8B4513",
    marginBottom: "0.5rem",
  },
  lastUpdated: {
    fontSize: "0.9rem",
    color: "#888",
    marginBottom: "1.5rem",
  },
  subheading: {
    fontSize: "1.4rem",
    fontWeight: "bold",
    color: "#8B4513",
    marginTop: "2rem",
    marginBottom: "0.75rem",
  },
  paragraph: {
    fontSize: "1rem",
    lineHeight: "1.8",
    color: "#333",
    marginBottom: "1rem",
  },
  link: {
    color: "#8B4513",
    fontWeight: "bold",
  },
};

export default Terms;
